Em.Handlebars.helper 'dateFormat', (context, format) ->
  formatString = if (typeof format is 'string') then format else 'DD/MM/YYYY'
  moment(context).format(formatString)

Em.Handlebars.helper 'humanizeDate', (context, format) ->
  return '' unless context

  m = moment(context)
  switch format
    when 'strict-date'
      m.format('D/MM/YYYY')
    when 'date'
      if m.isSame(moment(), 'day')
        # todo i18n
        'сегодня'
      else
        m.format('D MMMM')
    when 'time'
      m.format('HH:mm')
    else
      m.format(format)

Em.Handlebars.helper 'humanizeFromNow', (context) ->
  if context
    moment(context).fromNow()
  else
    ""

